import React from 'react';
import { Card } from '../retain100PercentOfRights/Retain100PercentOfRights';
import ScrollAnimation from 'react-animate-on-scroll';

const AutomateCatalogRegistration = () => {
  return (
    <div className="bg-lightgray">
      <div className="container noctil-solutions">
        <div className="pt--60">
          <div className="row">
            <div className="col-lg-12 text-center">
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                <h2>Automate accurate catalog registration at scale</h2>
              </ScrollAnimation>
            </div>
          </div>
          <div className="grid-center-cols--4">
            <Card
              imgPath={'/assets/images/redesignV2/25.png'}
              text={'Works and Repertoire Management'}
            />
            <Card
              imgPath={'/assets/images/redesignV2/26.png'}
              text={'Rights Holders Management'}
            />
            <Card
              imgPath={'/assets/images/redesignV2/27.png'}
              text={'Document and Asset Management with tagging'}
            />
            <Card
              imgPath={'/assets/images/redesignV2/33.png'}
              text={'Metadata Research'}
            />
            <Card
              imgPath={'/assets/images/redesignV2/28.png'}
              text={'Work and Repertoire Registration'}
            />

            <Card
              imgPath={'/assets/images/redesignV2/29.png'}
              text={'Registration Reports and Status'}
            />
            <Card
              imgPath={'/assets/images/redesignV2/34.png'}
              text={'Work list and Assignments'}
            />
            <Card
              imgPath={'/assets/images/redesignV2/30.png'}
              text={'Split Calculations, Distribution calculations & Payment reports'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutomateCatalogRegistration;
